module.exports = __webpack_public_path__ + "img/3.b72dc699.jpg";